<ridango-navigation-bar>
    <ul role="menu">
        <li role="menuitem">
            <a
                [routerLink]="'../personalize/travelcard' | localize"
                [routerLinkActiveOptions]="{ exact: false }"
                aria-current="page"
                routerLinkActive="active">
                {{ 'SUB_HEADER_PERSONALIZE' | translate }}
            </a>
        </li>

        <li *ngIf="helperService.isAllowedPath('/personalize/isic-card')" role="menuitem">
            <a
                [routerLink]="'isic-card' | localize"
                [routerLinkActiveOptions]="{ exact: false }"
                aria-current="page"
                routerLinkActive="active">
                {{ 'ISIC_CARD_ACTIVATION_FORM_TITLE' | translate }}
            </a>
        </li>
    </ul>
</ridango-navigation-bar>
<router-outlet></router-outlet>
